import React from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../component/header/HeaderThree";
import FooterTwo from "../../component/footer/FooterTwo";
import { FiChevronLeft } from "react-icons/fi";
import { useHistory, Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articleContent } from "./articleContent";
import { pressPath, articlePath, pageChrome } from "./pressContent";

const siteUrl = "https://ecoshift.eco";
const translatedLangs = ["en", "nl", "de"];

const PressArticlePage = () => {
  const history = useHistory();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  // No French translation is published (rights only cover the PDF as-is for
  // FR readers): if the site language is switched to French, whether by
  // direct link or live via the header dropdown, send readers back to the
  // press page, which already shows the FR PDF + original-article buttons.
  if (currentLang === "fr") {
    return <Redirect to={pressPath} />;
  }

  const lang = translatedLangs.includes(currentLang) ? currentLang : "en";
  const content = articleContent[lang];
  const chrome = pageChrome[lang];
  const pressHref = `${process.env.PUBLIC_URL}${pressPath}`;

  const handleBack = () => {
    if (document.referrer.includes("ecoshift.eco")) {
      history.goBack();
    } else {
      window.location.href = pressHref;
    }
  };

  return (
    <div className="active-dark bg_color--ugs">
      <Helmet>
        <title>{content.title} — EcoShift</title>
        <meta name="description" content={content.lede} />
        <meta property="og:title" content={content.title} />
        <meta property="og:description" content={content.lede} />
        <meta property="og:url" content={`${siteUrl}${articlePath}`} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${siteUrl}${articlePath}`} />
      </Helmet>

      <HeaderThree homeLink="/" logo="symbol-dark" color="color-black" alwaysSticky="true" />

      <div className="rn-blog-details">
        <div className="inner-wrapper">
          <div className="inner container">
            <p
              className="section-title-left text-color d-inline-flex align-items-center press-article__back"
              onClick={handleBack}
              style={{ cursor: "pointer" }}
            >
              <span className="back-button-border d-inline-flex align-items-center">
                <FiChevronLeft color="#fff" />
              </span>
              <span className="ml-2">{chrome.pageTitle}</span>
            </p>

            <p className="press-article__kicker">{content.kicker}</p>
            <h1 className="press-article__headline">{content.title}</h1>
            <p className="press-article__lede">{content.lede}</p>
            <p className="press-article__byline">{content.byline}</p>

            <div className="press-article__notice">
              <p>
                {content.sourceNote}{" "}
                <a href={content.sourceUrl} target="_blank" rel="noopener noreferrer">
                  {content.sourceUrl}
                </a>
              </p>
              <p>{content.translationNotice}</p>
            </div>

            <div className="press-article__body">
              {content.blocks.map((block, index) => {
                if (block.type === "h2") {
                  return <h2 key={index}>{block.text}</h2>;
                }
                if (block.type === "quote") {
                  return (
                    <blockquote key={index} className="rn-blog-quote">
                      &ldquo;{block.text}&rdquo;
                      <cite>{block.author}</cite>
                    </blockquote>
                  );
                }
                return <p key={index}>{block.text}</p>;
              })}
            </div>

            <div className="press-article__notice press-article__notice--footer">
              <p>
                {content.sourceNote}{" "}
                <a href={content.sourceUrl} target="_blank" rel="noopener noreferrer">
                  {content.sourceUrl}
                </a>
              </p>
              <p>{content.translationNotice}</p>
            </div>
          </div>
        </div>
      </div>

      <FooterTwo homeLink="/" />
    </div>
  );
};

export default PressArticlePage;
